export
const name: string = "SsaoBlur";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform sampler2D u_texture;
    uniform vec2 u_buffer_size;
    uniform vec4 u_view;
`;

export
const varyings: string = `
    varying vec2 v_texcoord;
`;

export
const implementation: string = `

    /**
     * Convert <0, 1> to <Offset, Size>
     */
    vec2 toViewCoords(in vec2 txCoords, in vec4 viewSize) {
        return txCoords * viewSize.zw + viewSize.xy;
    }

    float blur(float color, vec2 position)
    {
        vec2 texelSize = 1.0 / u_buffer_size;
    	float result = 0.0;
    	for (int i=-2; i<2; ++i) {
    		for (int a=-2; a<2; ++a) {
    			vec2 offset = vec2(float(i), float(a)) * texelSize;
    			float offsetColor = vec4ToFloat(texture2D(u_texture, position + offset));
    			//float offsetColor = texture2D(u_texture, position + offset).x;
    			if (offsetColor <= 0.0) {
    				offsetColor = 1.0;
    			}
    			result += offsetColor;
    		}
    	}
    	return result / 16.0;
    }

    void main(void) {
        vec2 texCoord = toViewCoords(v_texcoord, u_view);
        float color = vec4ToFloat(texture2D(u_texture, texCoord));
        float blurred = blur(color, texCoord);
        gl_FragColor = vec4(vec3(blurred), 1.0);
    }
`;
